import { DELAY } from 'src/app/core/utils/constants';
import { PETICIONES } from './../utils/constants';
import { Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Dbindexflds } from '../../core/entities/dbindexflds.model';
import { delay } from 'rxjs/operators';

@Injectable({
    providedIn: 'root'
})
export class DbindexfldsService {
    readonly BASE: any = PETICIONES.dbindexflds;

    constructor(private http: HttpClient) { }

    /**
   * @description
   * Obtiene todos los dbindexflds
   */
  public findAll(): Observable<any> {
    return this.http.get(this.BASE.findAll).pipe(delay(DELAY));
  }

  /**
   * @description
   * Obtiene un dbindexflds por su id
   */
  public findById(id: number): Observable<any> {
    let idbindexflds: string = (id !== undefined && id !== null ? id + "" : "");
    return this.http.get(this.BASE.findById + "/" + idbindexflds).pipe(delay(DELAY));
  }

  /**
   * @description
   * Guarda un dbindexflds en la base de datos
   */
  public postDbindexfld(dbindexflds: Dbindexflds): Observable<any> {
    const json = JSON.stringify(dbindexflds);
    const headers = new HttpHeaders().set('Content-Type', 'application/json;charset=UTF-8');
    return this.http.post(this.BASE.postDbindexflds, json, {headers: headers}).pipe(delay(DELAY));
  }

  /**
   * @description
   * Borra un dbindexflds en la base de datos
   */
  public deleteDbindexfld(dbindexflds: Dbindexflds): Observable<any> {
    let iddbindexflds: string = (dbindexflds.id !== undefined && dbindexflds.id !== null ? dbindexflds.id + "" : "");
    return this.http.get(this.BASE.deleteDbindexflds + "/" + iddbindexflds).pipe(delay(DELAY));
  }

}